import "../../../styles/Form.css";
import '../Overview.css';
import "es6-shim";
import * as React from "react";
import { EmailCheckin, MyleInstanceClinicSettings } from "../../../dtos/KioskDtos.dtos";
import EmailValidator from "../../../services/Validator/Email/Validator";
import { IGenericsLang, ILabelSelect } from "../../../services/Language/Types";
import PatientDefault from "../../../services/Initializer/PatientDefaultInitializer";
import { IsArrayNullOrUndefinedOrEmpty } from "../../../utilities/Commons";
import { EmailEdit } from "./EmailEdit";
import { useMutateArrayState } from "../../../hooks/useMutateArrayState.hook";
import { PatientContactInfoEditFooter } from "./PatientContactInfoEditFooter";
import { useScrollEffectWhenMounted } from "../../../hooks/useScrollEffectWhenMounted.hook";

interface IEmailsEditContainerProps {
    emails: EmailCheckin[];
    emailContactPointOptions: ILabelSelect[];
    text: IGenericsLang;
    focusedInputName: string;
    saveEmails: (emails: EmailCheckin[]) => void;
    cancel: () => void;
    onFocus: (pipe: (value: any) => void, value: any, mask: string, id: string) => void;
    disconnectKeyboard(): void;
    myleClinicSettings: MyleInstanceClinicSettings;
}

export const EmailsEditContainer = (props: IEmailsEditContainerProps) => {
    const [emails, mutateEmails] = useMutateArrayState<EmailCheckin>(props.emails);

    const listContainer = useScrollEffectWhenMounted([emails.length])

    const onEmailUpdate = (email: EmailCheckin, index: number) => mutateEmails(emailsState => emailsState[index] = email);

    const onEmailDeletion = (index: number) => mutateEmails(emailsState => emailsState.splice(index, 1));

    const onEmailAdd = () => mutateEmails(emailsState => emailsState.push(PatientDefault.newEmail));

    const isFormValid = () => {
        if (IsArrayNullOrUndefinedOrEmpty(emails)) {
            return true;
        }

        if (emails.some(x => !EmailValidator.validateEmail(x.address))) {
            return false;
        }

        return true;
    };

    return (
        <div>
            <div className="col-sm-12 contact-info-edit-container" ref={listContainer}>
                {emails.map((email, index) => (
                    <div className="row" key={"email-edit-" + index}>
                        <EmailEdit
                            email={email}
                            emailContactPointOptions={props.emailContactPointOptions}
                            index={index}
                            text={props.text}
                            focusedInputName={props.focusedInputName}
                            onDeleteEmail={() => onEmailDeletion(index)}
                            onEmailEdit={editedEmail => onEmailUpdate(editedEmail, index)}
                            onFocus={props.onFocus}
                            disconnectKeyboard={props.disconnectKeyboard}
                            myleClinicSettings={props.myleClinicSettings}
                        />
                    </div>
                ))}
            </div>
            <PatientContactInfoEditFooter
                text={props.text.labels}
                addElementTextLabel={props.text.labels.AddEmailLabel}
                isFormValid={isFormValid()}
                onAddElementClick={onEmailAdd}
                onCancelClick={props.cancel}
                onSaveElementsClick={() => props.saveEmails(emails)}
            />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/EmailsEditContainer.tsx